import { useLanguage } from '../../app/i18n/LanguageContext';
import './HomePage.css';

function HomePage() {
  const { language } = useLanguage();
  const welcomeText = language.startsWith('en') ? 'Welcome' : 'Hoş Geldiniz';

  return (
    <section className="home-page card">
      <h1 className="home-title">
        <span className="home-title-brand">RatioNexus</span>
        <span className="home-title-welcome">{welcomeText}</span>
      </h1>
    </section>
  );
}

export default HomePage;
